import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Campaign {
  id: string;
  name: string;
  status: 'draft' | 'active' | 'completed' | 'archived';
  startDate: string;
  endDate: string;
  budget: number;
}

interface CampaignState {
  campaigns: Campaign[];
  selectedCampaign: Campaign | null;
}

const initialState: CampaignState = {
  campaigns: [],
  selectedCampaign: null,
};

const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setCampaigns: (state, action: PayloadAction<Campaign[]>) => ({
      ...state,
      campaigns: action.payload,
    }),
    setSelectedCampaign: (state, action: PayloadAction<Campaign | null>) => ({
      ...state,
      selectedCampaign: action.payload,
    }),
  },
});

export const { setCampaigns, setSelectedCampaign } = campaignSlice.actions;

export default campaignSlice.reducer;
